import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const candidatePoolPage = {
    mobile: {  
        mainWrapper: {
            display: "flex",
            flexDirection: "column" as "column"
        },
        leftWrapper: {},
        rightWrapper: {},
        searchWrapper: {
            display: "none"
        },
        searchBar: {
            display: "none"
        },
        profileWrapper: {
            display: "flex"
        },
        newCandidate: {
            display: "flex",
            alignItems: "center",
            fontSize: "3.86vw",
            fontWeight: "bold" as "bold",
            color: Color.DeepBlack,
            padding: "0",
            iconWrapper: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "8.21vw",
                width: "8.21vw",
                background: Color.DeepBlack,
                boxShadow: "5px 5px 50px #00000027",
                borderRadius: "4.10vw",
                marginLeft: "2.41vw"
            },
            icon: {
                height: "2.90vw",
                width: "2.90vw",
                fill: Color.White
            }
        },
        status: {
            display: "flex",
            flexDirection: "column" as "column",
            padding: "6.04vw 2.41vw 0 4.83vw",
            title: {
                fontSize: "6.04vw",
                fontWeight: "bold" as "bold",
                color: Color.LightBlack,
                marginRight: "6.04vw"
            },
            tag: {
                display: "flex",
                flexDirection: "row"
            },
            find: {
                height: "8.45vw",
                lineHeight: "8.45vw",
                width: "42.02vw",
                textAlign: "center",
                borderRadius: "6.04vw",
                background: Color.LightAsh,
                color: Color.SharpAsh,
                padding: "0 3.62vw",
                fontSize: "4.34vw",
                fontWeight: "500",
                marginRight: "2.41vw",
                flex: "0 0 auto",
                cursor: "pointer",
                marginTop: "4.83vw"
            },
            // pending: {
            //     height: "8.45vw",
            //     lineHeight: "8.45vw",
            //     width: "auto",
            //     borderRadius: "6.04vw",
            //     background: Color.LightAsh,
            //     color: Color.SharpAsh,
            //     padding: "0 3.62vw",
            //     fontSize: "4.34vw",
            //     fontWeight: "500",
            //     marginRight: "2.41vw",
            //     flex: "0 0 auto",
            //     cursor: "pointer",
            //     marginTop: "4.83vw"
            // },
            selected: {
                background: Color.Blue,
                color: Color.White
            },
            addNew: {
                display: "none"
            }
        },
        search: {
            display: "flex",
            height: "12.07vw",
            margin: "4.83vw 2.41vw 0 0",
            fontSize: "4.34vw",
            width: "90.33vw",
            color: Color.Black,
            border: "none",
            borderRadius: "2.41vw",
            backgroundColor: Color.Cultured,
            input: {
                margin: "0",
                paddingLeft: "1.35vh",
                height: "12.07vw"
            },
            iconWrapper: {
                margin: "3.14vw 4.83vw 3.14vw auto"
            },
            icon: {
                width: "5.31vw",
                height: "5.79vw",
                fill: Color.SharpAsh,
                cursor: "text"
            }
        },
        findCandidate: {
            borderRadius: "2.41vw",
            border: "1px solid" + Color.MiddleAsh,
            margin: "4.83vw 4.83vw 13.28vw",
            title: {
                marginTop: "3.38vw",
                marginLeft: "4.34vw",
                fontSize: "3.86vw",
                color: Color.DeepAsh,
                fontWeight: "bold" as "bold"
            },
            text: {
                marginTop: "4.10vw",
                marginLeft: "9.66vw",
                fontSize: "4.34vw",
                fontWeight: "400",
                fontFamily: Font.Poppins,
                color: Color.SharpAsh
            },
            largeDropdown: {
                display: "flex",
                borderRadius: "2.41vw",
                height: "12.07vw",
                backgroundColor: Color.LightAsh,
                border: "none",
                width: "81.64vw",
                margin: "2.17vw 4.34vw 0 4.34vw"
            },
            largeInput: {
                margin: "0",
                paddingLeft: "4.83vw",
                fontSize: "4.34vw",
                width: "80%",
                height: "90%",
                color: Color.SharpAsh,
                backgroundColor: Color.LightAsh,
                borderRadius: "2.41vw",
                border: "none"
            },
            /* This feature needs to be implemented in the future */
            // icon: {
            //     height: "4.58vw",
            //     width: "4.1vw",
            //     marginLeft: "auto",
            //     marginRight: "8.69vw",
            //     alignSelf: "center",
            //     transition: "transform .1s ease-in-out",
            //     hover: {
            //         transform: "rotate(180deg)"
            //     }
            // },
            row: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                margin: "1.69vw 0",
                fontSize: "3.38vw",
                color: Color.DeepAsh
            },
            dateInput: {
                width: "50.03vw",
                height: "12.07vw",
                fontSize: "4.34vw",
                padding: "0 2.41vw",
                border: "none",
                borderRadius: "2.41vw",
                color: Color.SharpAsh,
                backgroundColor: Color.LightAsh,
                margin: "0 4.34vw 0 auto"               
            },
            dateText: {
                marginLeft: "9.66vw",
                fontSize: "4.34vw",
                fontWeight: "400",
                fontFamily: Font.Poppins,
                color: Color.SharpAsh
            },
            flexContainer: {
                display: "flex"
            },
            reset: {
                border: "2px solid " + Color.DeepBlack,
                color: Color.DeepBlack,
                marginLeft: "4.34vw",
                cursor: "pointer",
                textTransform: "uppercase",
                borderRadius: "2.41vw",
                fontFamily: Font.Default,
                fontWeight: "bold" as "bold",
                fontSize: "3.86vw",
                background: "transparent",
                WebkitTapHighlightColor: "transparent",
                width: "35.26vw",
                height: "12.07vw",
                marginTop: "5.31vw"
            },
            search: {
                color: Color.White,
                background: Color.Blue,
                height: "12.07vw",
                width: "39.85vw",
                margin: "5.31vw 4.34vw 7vw 6.52vw",
                borderRadius: "2.41vw",
                boxShadow: "5px 5px 50px #00000027",
                fontWeight: "bold" as "bold",
                fontSize: "4.83vw"
            }
        },
        candidateSelection:{
            title: {
                fontFamily: Font.Poppins,
                fontWeight: 600,
                fontSize: "6.03vw",
                color: Color.Black,
                marginLeft: "4.83vw"
            },
            sortWrapper: {
                display: "flex",
                flexDirection: "row" as "row"
            },
            sortSelect: {
                label:{
                    fontWeight: "unset"
                },
                buttonWrapper: {
                    width: "40vw",
                    height: "8.45vw"
                },
                button: {
                    width: "auto"
                },
                hover: {
                    width: "40vw"
                }
            },
            perPageSelect: {
                marginLeft: "auto",    
                marginRight: "4.83vw",
                label:{
                    fontWeight: "unset"
                },
                button: {
                    width: "14.97vw"
                },
                hover: {
                    width: "14.97vw"
                }
            },
            selectAllWrapper: {
                display: "flex",
                flexDirection: "row" as "row"
            },
            checkBox: {
                checkboxWrapper: {
                    margin: "5.79vw 0 4.31vw 4.83vw"
                },
                checkbox: {
                    height: "3.4vw",
                    width: "3.4vw"
                }
            },
            selectLabel: {
                marginLeft: "2.41vw"
            },
            sendEmailButton: {
                color: Color.White,
                background: Color.Green,
                height: "8.93vw",
                width: "38.81vw",
                borderRadius: "2.41vw",
                margin: "6.41vw 4.83vw 0 auto",
                fontWeight: "bold" as "bold",
                fontSize: "3.86vw"
            },
            // pickJob: {
            //     display: "flex",
            //     borderRadius: "2.41vw",
            //     height: "8.93vw",
            //     backgroundColor: Color.LightAsh,
            //     border: "none",
            //     width: "90.33vw",
            //     margin: "0 auto"
            // },
            // requestButton: {
            //     color: Color.White,
            //     background: Color.Green,
            //     height: "8.93vw",
            //     width: "48.81vw",
            //     margin: "2.41vw 41.52vw 6.68vw 4.83vw",
            //     borderRadius: "2.41vw",
            //     fontWeight: "bold" as "bold",
            //     fontSize: "3.86vw"
            // }
        }, 
        candidateList: {
            margin: "0 3.87vw 8.65vw 4.83vw"
        },
        candidateCard: {
            borderBottom: "2px solid" + Color.MiddleAsh,
            paddingBottom: "6vw",
            userProfile: {
                display: "flex",
                flexDirection: "row" as "row",
                marginTop: "5.79vw"
            },
            checkBox: {
                checkboxWrapper: {
                    alignItems: "unset"
                },
                checkbox: {
                    height: "3.38vw",
                    width: "3.38vw",
                    margin: "12.56vw 0 0 0"
                }
            },
            userAvatar: {
                height: "17.87vw",
                width: "17.87vw",
                borderRadius: "50%",                        
                marginRight: " 4.83vw",
                marginLeft: "8.14vw",
                objectFit: "cover"
            },
            name: {
                fontWeight: "bold" as "bold",
                fontSize: "3.86vw",
                maxWidth: "55vw", 
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
            },
            address: {
                fontSize: "2.65vw",
                color: Color.MiddleBlack,
                maxWidth: "55vw", 
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                marginTop: "1.20vw"
            },
            contactInfo: {
                marginTop: "2.89vw",
                color: Color.MiddleBlack
            },
            text: {
                fontSize: "3.38vw"
            },
            boldText: {
                fontWeight: "bold" as "bold",
                fontSize: "3.38vw"
            },
            email: {
                maxWidth: "55vw", 
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
            },
            jobInfo: {
                marginTop: "1.20vw",
                color: Color.MiddleBlack
            },
            viewCv: {
                color: Color.White,
                background: Color.DeepBlack,
                height: "8.45vw",
                width: "28.98vw",
                marginTop: "3.75vw",
                borderRadius: "1.69vw",
                fontWeight: "500",
                fontSize: "3.86vw"
            },
            viewCvIcon: {
                marginLeft: "1.93vw",
                stroke: Color.White,
                width: "2.88vw",
                height: "auto"
            },
            // pickJob: {
            //     display: "flex",
            //     borderRadius: "2.41vw",
            //     height: "8.93vw",
            //     backgroundColor: Color.LightAsh,
            //     border: "none",
            //     width: "83.15vw",
            //     margin: "3.75vw auto 0 8.14vw"
            // },
            // input: {
            //     color: Color.Black,
            //     margin: "0",
            //     paddingLeft: "4.83vw",
            //     fontSize: "4.34vw",
            //     width: "75%",
            //     backgroundColor: Color.LightAsh,
            //     borderRadius: "2.41vw",
            //     border: "none"
            // },
            // icon: {
            //     height: "4.58vw",
            //     width: "4.1vw",
            //     marginLeft: "auto",
            //     marginRight: "14.59vw",
            //     alignSelf: "center",
            //     transition: "transform .1s ease-in-out",
            //     up: {
            //         transform: "rotate(180deg)"
            //     }
            // },            
            // request: {
            //     color: Color.White,
            //     background: Color.Green,
            //     height: "8.45vw",
            //     width: "83.15vw",
            //     margin: "1.69vw 0 0 8.14vw",
            //     borderRadius: "2.41vw",
            //     fontWeight: "bold" as "bold",
            //     fontSize: "4.34vw"
            // }
        },
        perPageSelect: {
            marginLeft: "auto",                
            marginTop: "unset",
            buttonWrapper: { 
                width: "13.58vw"
            },
            button: {
                width: "auto",
                marginLeft: "auto"
            },
            hover: {
                width: "13.58vw"
            }
        },
        pagination: {
            nextButton: {
                width: "7.25vw",
                height: "7.25vw",
                backgroundColor: Color.DeepBlack,
                border: "none"
            },
            button: {
                color: Color.LightBlack,
                active: {
                    backgroundColor: Color.SharpAsh
                }
            }
        },
        addCandidate: {
            dialog: {            
                container: {                
                    width: "90%",
                    height: "auto",
                    padding: "7.48vw 4.83vw",
                    borderRadius: "3vw 3vw 0 0"
                },
                closeButton: {
                    width: "4.58vw",
                    height: "4.58vw",
                    top: "2.41vw",
                    right: "5.70vw",
                    overflow: "visible"
                }                      
            },
            content: {
                maxHeight: "70vh",
                overflowY: "auto",
                scrollbarWidth: "none"
            },
            dialogTitle: {
                color: Color.LightBlack,
                fontWeight: "bold" as "bold",
                fontSize: " 7.24vw",
                display: "inline-block",
                marginBottom: "2vw"
            },
            row: {
                display: "block"
            },
            lable: {
                color: Color.DeepAsh,
                fontFamily: Font.Poppins,
                fontSize: " 3.86vw",
                display: "inline-block",
                marginTop: "4.83vw"
            },
            rightInput: {
                marginTop: "1.11vh"
            },
            leftInput: {
                marginTop: "1.11vh"
            },
            sectorContainer: {
                display: "block",
                flexDirection: "unset",
                border: "1px solid " + Color.SharpAsh,
                borderRadius: "1.21vw",
                padding: "3.62vw",
                position: "relative",
                margin: "1.21vw 0"
            },
            valid: {
                backgroundColor: Color.LightBlue,
                border: "1px solid " + Color.Blue
            },
            invalid: {
                backgroundColor: Color.CoralRed,
                border: "1px solid " + Color.Red,
                color: Color.Red
            },
            sector: {
                width: "fit-content",
                height: "3.91vh",
                paddingLeft: "4.83vw",
                paddingRight: "4.83vw",
                marginRight: "1.21vw",
                textAlign: "center",
                lineHeight: "3.91vh",
                borderRadius: "6.04vw",
                backgroundColor: Color.Blue,
                color: Color.LightBlue,
                fontSize: "3.62vw",
                overflow: "hidden",
                cursor: "pointer",
                display: "inline-block",
                flex: "0 0 auto",
                WebkitTapHighlightColor: "transparent",
                userSelect: "none"
            },
            closeIcon: {
                position: "absolute",
                height: "2.23vh",
                width: "4.83vw",
                marginLeft: "1.45vw",
                marginTop: "-0.67vh",
            },
            allSectorWrapper: {
                border: "1px dashed " + Color.DarkGray,
                color: Color.SharpAsh,
                backgroundColor: "unset"
            },
            hover: {
                display: "block",
                position: "absolute",
                width: "100%",
                height: "33.59vh",
                bottom: "-34.59vh",
                left: "-0.5vw",
                backgroundColor: Color.White,
                border: "1px solid " + Color.MiddleAsh,
                borderRadius: "2.42vw",
                zIndex: 1
            },
            leave: {
                display: "none"
            },
            currentSector: {
                search: {
                    display: "flex",
                    height: "4.05vh",
                    width: "90%",
                    margin: "auto",
                    marginTop: "1.35vh",
                    fontSize: "3.38vw",
                    paddingLeft: "1.35vh",
                    color: Color.Black,
                    border: "none",
                    borderRadius: "4.16vw",
                    backgroundColor: Color.LightAsh
                },
                icon: {
                    position: "absolute" as "absolute",
                    width: "3.4vw",
                    height: "3.4vw",
                    fill: Color.SharpAsh,                
                    top: "8%",
                    left: "19.12vw"
                }
            },
            scrollArea: {
                height: "80%",
                overflow: "auto",
                marginTop: "1.38vw"
            },
            option: {
                margin: "0 2.19vw",
                padding: "0.312vw 2.19vw",
                textAlign: "left",
                color: Color.MiddleBlack,
                fontSize: "3.86vw",
                fontWeight: "medium",
                cursor: "pointer",
                zIndex: 1,
                WebkitTapHighlightColor: "transparent",
                userSelect: "none",
                hover: {
                    backgroundColor: Color.LightBlue,
                    borderRadius: "1.93vw"
                },
                leave: {
                    backgroundColor: Color.White
                }
            },
            bottomBorder: {
                border: 0,
                height: "1px",
                width: "92%",
                background: Color.MiddleAsh,
                margin: "0 auto",
                zIndex: "1"
            },
            hoveredBorder: {
                background: Color.White,
                borderRadius: "1px"
            },
            inputError: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-evenly",
                fontSize: "4.44vw",
                textAlign: "center",
                icon: {
                    width: "4.17vw",
                    height: "4.17vw",
                    overflow: "unset",
                    position: "absolute",
                    right: 10,
                    top: "50%",
                    transform: "translateY(-50%)"
                }
            },
            fileWarning: {
                color: Color.SharpAsh,
                fontSize: " 3.86vw",
                display: "inline-block",
                marginTop: "2.41vw",
                bold: {
                    fontWeight: "500",
                }
            },
            addPool: {
                color: Color.White,
                background: Color.Green,
                height: "12.07vw",
                width: "89.57vw",
                margin: "10.14vw 0 8.21vw 0",
                borderRadius: "2.41vw",
                fontWeight: "bold" as "bold",
                fontSize: "4.83vw"
            }
        },
        noCandidates: {
            wrapper: {
                borderRadius: "2.77vw",
                border: "1px solid " + Color.HarvestGold,
                backgroundColor: Color.LightGold,
                display: "flex",
                alignItems: "center" as "center",
                justifyContent: "center" as "center",
                padding: "2.41vh",
                color: Color.HarvestGold,
                fontSize: "4.5vw",
                fontFamily: Font.Poppins,
                margin: "21.73vw auto 0 auto",
                textAlign: "center"
            },
            icon: {
                marginRight: "1.43vw",
                width: "8.33vw",
                height: "8.33vw",
                marginLeft: "1vw"
            }
        },
        select: {
            wrapper: {
                width: "81.64vw",
                height: "8.93vw",     
                backgroundColor: Color.LightAsh,                           
                marginTop: "2.17vw",                        
                marginRight: "3.62vw",
                marginLeft: "4.34vw",
                borderRadius: "1.11vh",
                paddingTop: "3.14vw",
                WebkitTapHighlightColor: "transparent"
            },
            label: {
                display: "none"
            },
            button: {
                width: "auto",                
                backgroundColor: "transparent",
                color: Color.Black,
                fontSize: "3.86vw",
                fontWeight: "medium",
                border: "none",
                cursor: "pointer"
            },
            buttonWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                gap: "28.26vw",
                paddingRight: "5vw",
                paddingBottom: "25%"
            },
            buttonText: {
                marginLeft: "4.83vw",
                fontSize: "4.34vw",
                color: Color.SharpAsh,
                width: " 36.74vw"
            },
            buttonIcon: {
                width: "3.33vw",
                height: "3.33vw",
                fill: Color.Black,                
                marginLeft: "1.93vw",      
                alignSelf: "center",          
                transition: "transform .1s ease-in-out",
                hover: {
                    transform: "rotate(180deg)"
                }
            },
            leave: {
                display: "none"
            },
            hover: {
                display: "block",
                position: "absolute" as "absolute",
                width: "calc(100% - 24.93vw)",
                height: "56.52vw",
                WebkitOverflowScrolling: "touch",
                padding: "0 2.41vw 1.35vh",
                left: "0",
                backgroundColor: Color.White,
                borderRadius: "1.35vh",
                border: "1px solid " + Color.LightSilver,
                zIndex: 1,
                marginLeft: "9.83vw",
                marginTop: "-15.3vw"
            },
            search: {
                display: "flex",
                height: "7.25vw",
                width: "calc(100% - 8.45vw)",
                margin: "2.41vw 2.41vw 0 2.41vw",
                fontSize: "3.38vw",
                paddingLeft: "1.35vh",
                color: Color.Black,
                border: "none",
                borderRadius: "3.62vw",
                backgroundColor: Color.LightAsh,
                iconWrapper: {
                    position: "absolute" as "absolute",
                    top: "4.5vw",
                    left: "21vw"
                },
                icon: {
                    width: "2.41vw",
                    height: "3vw",
                    fill: Color.SharpAsh,
                    cursor: "text"
                }
            },
            scrollArea: {
                height: "82%",
                overflow: "auto",
                marginTop: "1.38vw"
            },
            option: {
                margin: "0 1.38vw",
                padding: "1.44vw 0.46vw",
                cursor: "pointer",
                position: "relative" as "relative",
                display: "flex",
                zIndex: 1,
                hover: {
                    backgroundColor: Color.LightBlue,
                    margin: "0 1.38vw",
                    borderRadius: "1.69vw"
                },
                leave: {
                    backgroundColor: "unset",
                },
            },
            checkbox: {
                borderRadius: "0.5vw",
                marginTop: "0.8vw",
                zIndex: 0,
                cursor: "pointer",
                border: "0.07vw solid " + Color.SharpAsh,
                height: "2.65vw",
                width: "2.65vw",
                float: "left",
                marginLeft: "2.17vw"
            },
            checkMark: {
                marginLeft: "2.25vw",
                marginTop: "0.8vw",
                height: "2.72vw",
                width: "2.72vw",
                float: "left"
            },
            optionLabel: {
                cursor: "pointer",
                marginLeft: "3.62vw",
                fontSize: "3.86vw",
                fontWeight: "500",
                maxWidth: "60vw",
                color: Color.MiddleBlack
            },
            bottomBorder: {
                border: 0,
                height: "1px",
                width: "92%",
                background: Color.MiddleAsh,
                margin: "0 auto",
                zIndex: "1"
            },
            hoveredBorder: {
                background: Color.White,
                borderRadius: "1px"
            }
        },
        viewCV: {
            popup: {
                justifyContent: "center",
                container: {
                    width: "90.33vw",
                    height: "166.67vw",
                    borderRadius: "2.41vw",
                    padding: "2.41vw"
                },
                closeButton: {
                    width: "3.86vw",
                    height: "3.86vw",
                    top: "1.93vw",
                    right: "1.93vw"
                }
            },           
            documentViewer: {
                height: "100%"
            }
        },
        valid: {
            backgroundColor: Color.LightBlue,
            border: "1px solid " + Color.Blue
        },
        invalid: {
            backgroundColor: Color.CoralRed,
            border: "1px solid " + Color.Red,
            color: Color.Red
        },
        inputError: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-evenly",
            fontSize: "4.44vw",
            textAlign: "center",
            icon: {
                width: "4.17vw",
                height: "4.17vw",
                overflow: "unset",
                position: "absolute",
                right: 10,
                alignSelf: "anchor-center"
            }
        },
        popUpTabs: {
            container: {                
                width: "90%",
                height: "57%",
                padding: "7.48vw 4.83vw",
                borderRadius: "0",
                maxHeight: "70vh", 
                overflowY: 'auto'
            },
            closeButton: {
                width: "4.58vw",
                height: "4.58vw",
                top: "3.41vw",
                right: "5.70vw"
            } 
        },
        popUpContainer: {
            content: {
                padding: "7.48vw 4.83vw"
            },
            backButton: {
                display: "flex",
                alignItems: "center",
                button: {
                    paddingTop: "0.7vw",
                    width: "6.76vw",
                    height: "6.76vw",
                    backgroundColor: Color.LightAsh,
                    borderRadius: "50%"
                },
                icon: {
                    fill: Color.DeepBlack,
                    width: "50%"
                },
                text: {
                    display: "inline",
                    marginLeft: "2.65vw",
                    fontSize: "3.86vw",                
                    color: Color.LightBlack
                }
            },
            profileContainer: {
                display: "flex",
                flexDirection: "row" as "row",
                marginTop: "5.79vw"
            },
            profileImage: {
                height: "24.33vw",
                width: "24.33vw",
                borderRadius: "50%",
                objectFit: "cover"                  
            },
            detailsWrapper: {
                marginLeft: "3.85vw",
                name: {
                    fontSize: "6.03vw",
                    fontWeight: "bold" as "bold",
                    color: Color.LightBlack,
                    wordBreak: 'break-word'
                },
                recentEmployer: {
                    marginTop: "1.2vw",
                    fontSize: "3.86vw",
                    fontWeight: "bold" as "bold",
                    color: Color.LightBlack
                },
                preferredRole: {
                    marginTop: "1.04vw",
                    fontSize: "3.86vw",
                    bold: {
                        fontWeight: "bold" as "bold"
                    }
                }
            },
            tabs: {
                container: {
                    marginTop: "3.96vh"
                },
                linkWrapper: {
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: Color.LightAsh,
                    width: "fit-content",
                    margin: "0 -4.83vw 0 0"
                },
                link: {
                    flexShrink: "0",
                    fontSize: "3.86vw",
                    color: Color.DeepAsh,
                    borderRadius: "1.20vw",
                    padding: "2.65vw",
                    alignSelf: "center",
                    cursor: "pointer",
                    active: {
                        backgroundColor: Color.DeepBlack,
                        color: Color.LightAsh,
                        position: "sticky",
                        right: "0",
                        left:"0"
                    },
                    WebkitTapHighlightColor: "transparent"
                }
            }
        },
        emailContainer: {
            content: {
                padding: "5.79vw 4.83vw 7.48vw"
            },
            backButton: {
                display: "flex",
                alignItems: "center",
                marginBottom: "4.83vw",
                button: {
                    paddingTop: "0.7vw",
                    width: "6.76vw",
                    height: "6.76vw",
                    backgroundColor: Color.LightAsh,
                    borderRadius: "50%"
                },
                icon: {
                    fill: Color.DeepBlack,
                    width: "50%"
                },
                text: {
                    display: "inline",
                    marginLeft: "2.65vw",
                    fontSize: "3.86vw",                
                    color: Color.LightBlack
                }
            },
            container: {
                width: "calc(100% - 9.66vw)",
                height: "auto",
                padding: "6.246vw 4.93vw",
                borderRadius: "2.415vw 2.415vw 0 0"
            },
            title: {
                fontWeight: 700,
                fontSize: "6.04vw",
                color: Color.LightBlack
            },
            actionButtons: {
                display: "flex",
                gap: "2.41vw",
                marginTop: "3vw",
                width: "auto"
            },
            sendCopyButton: {
                color: Color.Blue,
                cursor: "pointer",
                fontSize: "4.34vw",
                marginLeft: "auto"
            },
            verticalLine: {
                borderLeft: "0.95vw solid " + Color.DeepAsh
            },
            addAttachmentButton: {
                color: Color.Blue,
                cursor: "pointer",
                paddingRight: "0",
                fontSize: "4.34vw"
            },
            fieldGroup: {
                display: "flex",
                flexDirection: "column",      
                marginTop: "2.41vw"
            },
            label: {
                fontSize: "3.86vw",
                marginTop: "1.04vw",
                color: Color.DeepAsh,
                fontFamily: Font.Poppins,
                recipients: {
                    marginTop: "2.43vw"
                }
            },
            input: {
                padding: "1.93vw",
                border: "1px solid" + Color.MiddleAsh,
                backgroundColor: Color.White,
                borderRadius: "1.44vw",
                marginTop: "1.20vw",
                fontSize: "3.38vw"
            },
            emailInputWrapper: {
                display: 'flex',
                position: "relative",
                boxSizing: "border-box",
                minHeight: "12.08vw",
                flexWrap: 'wrap',    
                padding: '1.93vw 2.89vw',
                border: "1px solid" + Color.MiddleAsh,
                marginTop: "1.2vw",
                alignItems: "center",
                borderRadius: '1.44vw',
                content: {
                    width: "95%"
                },
                input: {
                    border: "none",
                    outline: "none",
                    fontSize: "3.38vw",
                    backgroundColor: "transparent",
                    padding: "0"
                }
            },
            emailTag: {
                display: 'inline-flex',
                alignItems: 'center',
                backgroundColor: Color.SharpGreen,
                border: '1px solid' + Color.Green,
                borderRadius: '3.86vw',
                padding: '1.20vw 2.89vw',
                gap: '1.93vw',
                fontFamily: Font.Poppins,
                fontSize: '3.38vw',
                margin: "0 1.5vw 1.5vw 0",
                width: "fit-content",
                text: {
                    color: Color.Black,
                    lineHeight: '1.2',
                    wordBreak: 'break-word'
                },
                removeButton: {
                    cursor: 'pointer',
                    width: '4.34vw',
                    height: '4.34vw',
                    overflow: "visible"
                }
            },
            emailEditor: {
                marginTop: "1.2vw",
                borderRadius: "1.44vw",
                border: "0.24vw solid" + Color.MiddleAsh
            },
            actions: {
                display: "flex",
                justifyContent: "flex-end",
                gap: "2.41vw",
                marginTop: "2.89vw"
            },
            sendButton: {
                backgroundColor: Color.Green,
                fontWeight: "bold",
                color: Color.White,
                width: "43.96vw",
                height: "9.66vw",
                fontSize: "3.86vw",
                padding: "1.93vw 3.86vw",
                borderRadius: "1.44vw"
            },
            cancelButton: {
                backgroundColor: Color.MiddleBlack,
                fontWeight: "bold",
                color: Color.White,
                width: "43.96vw",
                height: "9.66vw",
                fontSize: "3.86vw",
                padding: "1.93vw 3.86vw",
                borderRadius: "1.44vw"
            },
            attachment: {
                display: 'flex',
                flexWrap: 'wrap',
                marginTop: "1.2vw",
                padding: "1.93vw 2.89vw",
                border: "1px solid" + Color.MiddleAsh,
                borderRadius: '1.44vw',
                boxSizing: "border-box",
                height: "12.08vw",
                alignItems: "center",
                overflow: 'hidden'
            },
            attachmentItem: {
                display: 'flex',
                gap: '1.93vw',
                fontFamily: Font.Poppins,
                fontSize: '3.38vw'
            },
            attachmentName: {
                color: Color.Black,
                wordBreak: 'break-word'
            },
            attachmentRemove: {
                cursor: 'pointer',
                width: '4.34vw',
                height: '4.34vw',
                marginTop: '1vw',
                overflow: "visible"
            },
            valid: {
                backgroundColor: Color.LightBlue,
                border: "1px solid " + Color.Blue
            },
            invalid: {
                backgroundColor: Color.CoralRed,
                border: "1px solid " + Color.Red,
                color: Color.Red
            },
            invalidMessage: {
                position: "absolute",
                right: "2.2%"
            },
            inputError: {
                width: "max-content",
                icon: {
                    width: "4.17vw",
                    height: "4.17vw",
                    overflow: "unset"
                }
            }
        }
    },
    desktop: {
        mainWrapper: {            
            flexDirection: "row" as "row",
            padding: "1.56vw"
        }, 
        rightWrapper: {
            width: "100%",
            paddingLeft: "2.32vw"
        },
        searchWrapper: {
            display: "flex",
            flexDirection: "row" as "row",
            height: "4.68vw"
        },
        searchBar: {
            display: "flex",
            alignItems: 'center',
            position: 'relative',
            backgroundColor: Color.Cultured,
            marginTop: "0.52vw",
            marginBottom: "1.56vw",
            width: "25.21vw",
            borderRadius: "0.52vw",
            height: "2.6vw",
            input: {
                border: "none",
                backgroundColor: Color.Cultured,
                width: "21vw",
                paddingLeft: "1.04vw"
            },
            icon: {
                position: "absolute" as "absolute",
                fill: Color.SharpAsh,
                width: "1.14vw",
                height: "1.25vw",
                left: '23.06vw',
                cursor: "pointer"
            }
        },
        profileWrapper: {
            marginLeft: "auto"
        },
        status: {
            padding: "1.35vw 0 0 0.42vw",
            flexDirection: "row" as "row",
            title: {
                color: Color.DeepBlack,
                fontSize: "2.6vw",
                marginRight: "2.08vw"
            },
            tag: {
                alignItems: "center"
            },
            find: {
                height: "1.82vw",
                lineHeight: "1.82vw",
                width: "9.06vw",
                borderRadius: "1.3vw",
                padding: "0 1.04vw",
                fontSize: "0.93vw",
                marginRight: "0.52vw",
                marginTop: "none"
            },
            // pending: {
            //     height: "1.82vw",
            //     lineHeight: "1.82vw",
            //     width: "auto",
            //     borderRadius: "1.3vw",
            //     padding: "0 1.04vw",
            //     fontSize: "0.93vw",
            //     marginRight: "none",
            //     marginTop: "none"
            // },
            addNew: {
                display: "flex",
                background: Color.DeepBlack,
                color: Color.White,
                boxShadow: "5px 5px 50px #00000027",
                fontWeight: "bold" as "bold",
                marginLeft: "auto",
                width: "13.59vw",
                height: "2.60vw",
                borderRadius: "0.52vw",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "0.83vw",
                alignSelf: "center"
            },
            addNewIcon: {
                height: "0.88vw",
                width: "0.88vw",
                fill: Color.White,
                marginLeft: "0.68vw"
            }
        },
        count: {
            margin: "0.32vw 0 0.87vw 0.59vw",
            opacity: 1,
            fontSize: "0.83vw",
            fontWeight: "300vw",
            fontFamily: Font.Poppins,
            color: Color.DeepAsh
        },
        findCandidate: {
            borderRadius: "0.52vw",
            border: "1px solid" + Color.MiddleAsh,
            margin: "0 0 0 0.59vw",
            title: {
                marginTop: "0.72vw",
                marginLeft: "0.93vw",
                fontSize: "0.83vw"
            },
            filterSection: {
                display: "flex",
                flexDirection: "column"
            },
            firstRow: {
                display: "flex",
                flexDirection: "row" as "row"
            },
            secondRow: {
                display: "flex",
                flexDirection: "row" as "row"
            },
            sector: {
                marginRight: "1.04vw",
                width: "17.56vw"
            },
            location: {
                marginRight: "1.04vw",
                width: "16.56vw"
            },
            text: {
                marginTop: "0.88vw",
                marginLeft: "2.08vw",
                fontSize: "0.93vw",
                width: "12.05vw"
            },
            largeDropdown: {
                borderRadius: "0.52vw",
                height: "2.60vw",
                width: "23.20vw",
                margin: "0.46vw 0vw 0 1.04vw"
            },
            largeInput: {
                paddingLeft: "1.04vw",
                fontSize: "0.93vw",
                borderRadius: "0.52vw",
                height: "auto"
            },
            // icon: {
            //     height: "0.98vw",
            //     width: "0.88vw",
            //     marginLeft: "auto",
            //     marginRight: "1.87vw",
            //     alignSelf: "center"
            // },
            dateWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                marginLeft: "1.04vw"
            },
            row: {
                margin: "0.46vw 0",
                fontSize: "3.38vw",
            },
            dateInput: {
                width: "11.83vw",
                height: "2.60vw",
                fontSize: "0.93vw",
                padding: "0 1.07vw",
                borderRadius: "0.52vw",
                margin: "0 0 0 auto"               
            },
            dateText: {
                margin: "0.88vw 1.04vw 0",
                fontSize: "0.93vw"
            },
            flexContainer: {
                marginLeft: "auto",
                marginRight: "0"
            },
            reset: {
                marginLeft: "0",
                borderRadius: "0.52vw",
                fontSize: "0.83vw",
                width: "7.60vw",
                height: "2.60vw",
                marginTop: "1.36vw"
            },
            search: {
                height: "2.60vw",
                width: "8.59vw",
                margin: "1.36vw 0.9vw 1.40vw 1.04vw",
                borderRadius: "0.52vw",
                fontSize: "1.04vw"
            }
        },
        candidateSelection:{
            display: "flex",
            flexDirection: "colomn" as "colomn",
            titleWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                marginTop: "3.42vw"
            },
            title: {
                fontSize: "1.25vw",
                marginLeft: "0.59vw",
                display: "inline-block"
            },
            sortWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                marginLeft: "1.66vw"
            },
            sortSelect: {
                marginLeft: "0",
                label: {
                    fontSize: "0.83vw"
                },
                buttonWrapper: {
                    width: "11vw",
                    height: "1.82vw"
                },
                button: {
                    width: "11vw",
                    height: "1.82vw"
                },
                hover: {
                    width: "11vw",
                    allignSelf: "center"
                },
                option: {
                    textAlign: "center"
                }
            },
            selectWrapper: {
                display: "flex",
                flexDirection: "colomn" as "colomn"
            },
            // pickJob: {
            //     borderRadius: "0.52vw",
            //     height: "1.92vw",
            //     width: "11.04vw",
            //     margin: "3.32vw 0 0 1.66vw"
            // },
            // requestButton: {
            //     height: "1.92vw",
            //     width: "11.77vw",
            //     margin: "3.33vw 0 0 0.83vw",
            //     borderRadius: "0.52vw",
            //     fontSize: "0.83vw",
            //     justifyContent: 'space-between'
            // },
            sendEmailButton: {
                height: "1.92vw",
                width: "9.77vw",
                margin: "3.33vw 0 0 0.83vw",
                borderRadius: "0.52vw",
                fontSize: "0.83vw",
                justifyContent: 'space-between'
            },
            selectLabel: {
                display: "inline-block",
                marginLeft: "0.52vw",
                marginTop: "0.32vw",
                fontSize: "0.78vw"
            },
            checkBoxRow: {
                checkbox: {
                    margin: "0.32vw 0 1.04vw 0.59vw",
                    borderRadius: "0.15vw"
                }
            }
        },
        candidateList: {
            margin: "1.04vw 0 2.60vw 0"
        },
        candidateCard: {
            borderBottom: "1px solid" + Color.MiddleAsh,
            padding: "1.05vw 0 0vw ",
            userProfile: {
                marginTop: "0"
            },
            userInfo: {
                width: "15.98vw"
            },
            checkBox: {
                checkbox: {
                    height: "0.72vw",
                    width: "0.72vw",
                    borderRadius: "0.15vw",
                    margin: "1.58vw 0 0 0.93vw"
                }
            },
            details: {
                display: "flex",
                flexDirection: "colomn" as "colomn",
                paddingBottom: "unset"
            },
            userAvatar: {
                height: "3.85vw",
                width: "3.85vw",          
                margin: "0 1.04vw 0.94vw 2.5vw"
            },
            name: {
                maxWidth: "14vw",
                fontSize: "1.04vw",
                marginTop: "0.71vw",
            },
            address: {
                maxWidth: "14vw", 
                fontSize: "0.83vw",
                marginTop: "0.28vw"
            },
            contactInfo: {
                marginTop: 0,
                marginLeft: "1.82vw",
                width: "13.54vw"
            },
            text: {
                fontSize: "0.83vw"
            },
            boldText: {
                marginTop: "0.28vw",
                fontSize: "0.83vw",
                maxWidth: "8vw", 
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                recentJobTitle: {
                    maxWidth: "none" 
                },
                hovered: {
                    maxWidth: "8vw"
                }
            },
            email: {
                maxWidth: "14vw"
            },
            jobInfo: {
                marginTop: "0",
                marginLeft: "3.48vw",
                width: "20vw",
                hovered: {
                    width: "6.92vw"
                }
            },
            viewCvButton: {
                position: "absolute",
                right: "3vw"
            },
            viewCv: {
                height: "1.82vw",
                width: "6.25vw",
                marginTop: "0.98vw",
                borderRadius: "0.36vw",
                fontSize: "0.83vw"
            },
            viewCvIcon: {
                marginLeft: "0.60vw",
                width: "0.58vw",
                height: "auto"
            },
            // pickJobWrapper: {
            //     marginLeft: "2.94vw"
            // },
            // pickJob: {
            //     borderRadius: "0.52vw",
            //     height: "1.82vw",
            //     width: "11.04vw",
            //     margin: "0 auto 0"
            // },
            // input: {
            //     paddingLeft: "1.04vw",
            //     fontSize: "0.93vw",
            //     width: "75%",
            //     borderRadius: "0.52vw"
            // },
            // icon: {
            //     height: "0.98vw",
            //     width: "0.88vw",
            //     marginLeft: "auto",
            //     marginRight: "1.87vw",
            //     alignSelf: "center"
            // },         
            // request: {
            //     height: "1.82vw",
            //     width: "11.04vw",
            //     margin: "0.36vw auto 0",
            //     borderRadius: "0.52vw",
            //     fontSize: "0.93vw"
            // },
            bottomBorder: {
                borderBottom: "1px solid " + Color.MiddleAsh
            },
            hovered: {
                background: Color.White,
                borderTop: "1px solid " + Color.MiddleAsh,
                borderLeft: "1px solid " + Color.MiddleAsh,
                borderBottom: "1px solid " + Color.MiddleAsh,
                borderRight: "1px solid " + Color.MiddleAsh,
                borderRadius: "0.52vw",
                boxShadow: "10px 10px 50px #00000014"
            }
        },
        paginationWrapper: {
            display: "flex",
            alignItems: "center",
            marginTop: "2.10vw"
        },
        perPageSelect: {
            marginLeft: "0.59vw",                
            marginTop: "unset",
            label: {
                fontSize: "0.83vw"
            },
            buttonWrapper: { 
                marginLeft: "1.04vw",
                width: "4.06vw"
            },
            button: {
                width: "auto",
                marginLeft: "auto"
            },
            hover: {
                marginLeft: "1.04vw",
                width: "4.06vw"
            }
        },
        pagination: {
            margin: "unset",
            marginLeft: "auto",
            nextButton: {
                width: "2.60vw",
                height: "2.60vw",
            }
        },
        addCandidate: {
            dialog: {            
                container: {                
                    width: "47.70vw",
                    height: "auto",
                    padding: "2.60vw 2.60vw 2.58vw 3.12vw",
                    borderRadius: "0.52vw",
                    marginLeft: "8.5vw",
                    border: "2px solid " + Color.LightAsh
                },
                closeButton: {
                    width: "1.34vw",
                    height: "1.34vw",
                    top: "0.52vw",
                    right: "0.52vw",
                    overflow: "visible"
                }                      
            },
            content: {
                maxHeight: "80vh"
            },
            dialogTitle: {
                fontSize: "1.56vw",
                marginBottom: "2.08vw",
                color: Color.DeepBlack
            },
            row: {
                display: "flex"
            },
            lable: {
                fontSize: "0.93vw",
                marginTop: "0.72vw"
            },
            leftInputWrapper: {
                width: "23.46vw"
            },
            rightInputWrapper: {
                marginLeft: "0.62vw",
                width: "23.46vw"
            },
            rightInput: {
                marginTop: "0.92vh"
            },
            leftInput: {
                marginTop: "0.92vh"
            },
            sectorContainer: {
                borderRadius: "0.52vw",
                padding: "0.5vw",
                margin: "0.52vw 0"
            },
            sector: {
                margin: "0.26vw 0.52vw",
                width: "fit-content",
                height: "1.822vw",
                paddingLeft: "1.04vw",
                paddingRight: "1.04vw",
                lineHeight: "1.822vw",
                fontSize: "0.78vw"
            },
            closeIcon: {
                height: "1.04vw",
                width: "1.04vw",
                marginLeft: "0",
                marginTop: "-0.67vh"
            },
            allSectorWrapper: {
                width: "7.39vw",
                overflow: "visible",
                verticalAlign: "bottom",
                position: "relative"
            },
            hover: {
                width: "15.15vw",
                borderRadius: "0.52vw",
                height: "15.67vw",
                padding: "0.52vw",
                position: "unset"
            },
            hoverWrapper: {
                position: "absolute",
                paddingTop: "0.52vw",
                left: "-7%",
                zIndex: "1"
            },
            currentSector: {
                search: {
                    height: "1.562vw",
                    fontSize: "0.72vw",
                    marginTop: "0.52vw"
                },
                icon: {
                    width: "0.62vw",
                    height: "0.62vw",
                    left: "4.60vw",
                    top: "2.15vw"
                }
            },
            scrollArea: {
                height: "83%",
                marginTop: "0.52vw"
            },
            option: {
                margin: "0",
                padding: "0 0.52vw",
                fontSize: "0.78vw",
                hover: {
                    borderRadius: "0.36vw"
                }
            },
            cvUpload: {
                cursor: "pointer",
                selectedFileName: {
                    width: "30vw"
                }
            },
            addPoolWrapper: {
                display: "flex",
                flexDirection: "column" as "column",
                marginTop: "0.52vw"
            },
            fileWarning: {
                fontSize: "0.83vw",
                marginTop: "0.52vwvw"
            },
            inputError: {
                fontSize: "1vw",
                icon: {
                    width: "1.05vw",
                    height: "1.05vw",
                    right: 8
                }
            },
            addPool: {
                height: "3.64vw",
                width: "19.53vw",
                margin: "1.56vw auto 0",
                borderRadius: "0.52vw",
                fontSize: "1.04vw"
            }
        },
        noCandidates: {
            wrapper: {
                width: "75%",
                borderRadius: "0.52vw",
                margin: "10vh auto 0 auto",
                padding: "1.56vw 0 1.56vw 0",
                fontSize: "1.137vw"
            },
            icon: {
                marginRight: "1.02vw",
                width: "1.58vw",
                height: "1.58vw"
            }
        },
        select: {
            wrapper: {
                height: "auto",
                position: "absolute" as "absolute",
                marginTop: "0.46vw",
                marginRight: "0",
                marginLeft: "1.04vw",
                padding: "0.8vw 0 0",
                paddingRight: "0",
                width: "17.56vw"
            },
            button: {
                width: "100%",
                height: "100%",
                fontSize: "1.17vw"
            },
            buttonWrapper: {                
                marginTop: "unset",
                gap: "5.6vw",
                height: "1vw",
                paddingRight: "unset",
                paddingBottom: "0.8vw",
                sector: {
                    gap: "ünset"
                }
            },
            buttonText: {
                fontSize: "0.93vw",
                marginLeft: "1.04vw",
                width: "8vw"
            },
            buttonIcon: {
                width: "0.8vw",
                height: "0.93vw",
                marginLeft: "0.72vw",
                marginRight: "5%"
            },
            hover: {
                height: "11.14vw",
                padding: "0.52vw",
                left: "0",
                borderRadius: "0.52vw",
                marginLeft: "0",
                width: "12.90vw",
                top: "2.5vw",
                marginTop: "0"
            },
            search: {
                width: "90%",
                fontSize: "0.72vw",
                height: "1.56vw",
                borderRadius: "0.78vw",
                margin: "0",
                paddingLeft: "0.78vw",
                iconWrapper: {
                    position: "absolute",
                    top: "0.7vw",
                    left: "4.32vw"
                },
                icon: {
                    width: "0.78vw",
                    height: "unset"
                }
            },
            scrollArea: {
                marginTop: "0.36vw"
            },
            option: {
                margin: "0",
                padding: "0.36vw",
                hover: {
                    margin: "0",
                    borderRadius: "0.364vw"
                }
            },
            optionLabel: {
                fontSize: "0.83vw",
                marginLeft: "0.51vw",
                maxWidth: 'calc(100% - 2vw)'
            },
            checkbox: {
                marginLeft: "0.46vw",
                borderRadius: "0.1vw",
                marginTop: "0.2vw",
                height: "0.57vw",
                width: "0.57vw"
            },
            checkMark: {
                marginLeft: "0.46vw",
                marginTop: "0.2vw",
                height: "0.7vw",
                width: "0.7vw"
            }
        },
        viewCV: {
            popup: {
                container: {                    
                    width: "30.99vw",
                    height: "43.85vw",                    
                    borderRadius: "0.52vw",
                    padding: "0.83vw"
                },
                closeButton: {                    
                    width: "0.94vw",
                    height: "0.94vw",
                    top: "0.21vw",
                    right: "0.21vw"
                }
            }
        },
        inputError: {
            fontSize: "1vw",
            icon: {
                width: "1.05vw",
                height: "1.05vw",
                right: 8
            }
        },
        popUpTabs: {            
            container: {  
                position: "absolute",            
                width: "30vw",
                right: 0,
                top: 0,
                height: "100%",
                padding: "1.56vw 2.6vw",
                borderRadius: "unset",
                maxHeight: "unset", 
                overflowY: 'auto',
                scrollbarWidth: "none"
            },
            closeButton: {
                width: "1.34vw",
                height: "1.34vw",
                top: "0.52vw",
                right: "0.52vw",
                overflow: "visible"
            }                      
        },
        popUpContainer: {
            content: {
                padding: "0 0 2vw 0"
            },
            profileContainer: {
                marginTop: "unset"
            },
            profileImage: {
                height: "7.91vw",
                width: "7.91vw"                  
            },
            detailsWrapper: {
                marginLeft: "1.35vw",
                name: {
                    color: Color.DeepBlack,
                    marginTop: "unset",
                    fontSize: "1.56vw",
                    width: "20vw",
                },
                recentEmployer: {
                    marginTop: "0.52vw",
                    fontSize: "0.94vw",
                    maxWidth: "20vw"
                },
                preferredRole: {
                    marginTop: "0.41vw",
                    fontSize: "1.04vw"
                }
            },
            tabs: {
                container: {
                    marginTop: "3.37vh"
                },
                linkWrapper: {
                    borderRadius: "0.52vw"
                },
                link: {
                    fontSize: "0.83vw",
                    borderRadius: "0.52vw",
                    padding: "0.67vw 1.562vw",
                    marginRight: "0",
                    active: {
                        borderRadius: "0.52vw"                    
                    }
                },
                title: {
                    fontSize: "1.56vw",
                    marginTop: "4.63vh"
                } 
            }
        },
        emailContainer: {
            zIndex: "11",
            content: {
                padding: "0 0 2vw 0",
                maxHeight: "31.61vw",
                scrollbarWidth: "none",
                overflowY: "auto"
            },
            backButton: {
                display: "none"
            },
            container: {                
                width: "60vw",
                height: "auto",
                padding: "2.48vw 2.12vw",
                borderRadius: "0.52vw"
            },
            actionButtons: {
                gap: "1vw",
                marginTop: "unset"
            },
            sendCopyButton: {
                fontSize: "0.93vw"
            },
            verticalLine: {
                borderLeft: "0.4vw solid " + Color.DeepAsh
            },
            addAttachmentButton: {
                fontSize: "0.93vw"
            },
            title: {
                fontSize: "1.56vw",
                color: Color.DeepBlack
            },
            fieldGroup: {
                marginTop: "1.04vw"
            },
            label: {
                fontSize: "0.93vw",
                marginTop: "unset",
                recipients: {
                    marginTop: "unset"
                }
            },
            input: {
                padding: "0.52vw 1.04vw",
                borderRadius: "0.52vw",
                marginTop: "0.52vw",
                fontSize: "1.04vw",
                inputError: {
                    right: "0%"
                }
            },
            emailInputWrapper: {
                marginTop: "0.52vw",
                minHeight: "3.64vw",
                padding: "0.52vw 1.04vw",
                borderRadius: "0.52vw",
                content: {
                    display: 'block',
                    width: "98%"
                },
                input: {
                    fontSize: "0.93vw"
                }
            },
            emailTag: {
                borderRadius: '0.83vw',
                padding: "0.52vw 1.04vw",
                gap: '1.04vw',
                fontSize: "0.93vw",
                margin: "0 0.5vw 0.5vw 0",
                removeButton: {
                    width: '1vw',
                    height: '1vw',
                    alignSelf: "center"
                }
            },
            emailEditor: {
                marginTop: "1vw",
                minHeight: "22.76vw",
                borderRadius: "0.52vw",
                width: "auto",
                border: "0.05vw solid" + Color.MiddleAsh
            },
            actions: {
                gap: "1.04vw",
                marginTop: "1.04vw"
            },
            sendButton: {
                padding: "0.52vw 1.04vw",
                borderRadius: "0.52vw",
                fontSize: "0.83vw",
                width: "10.93vw",
                height: "2.60vw"
            },
            cancelButton: {
                padding: "0.52vw 1.04vw",
                borderRadius: "0.52vw",
                fontSize: "0.83vw",
                width: "10.93vw",
                height: "2.60vw"
            },
            attachment: {
                marginTop: "0.52vw",
                padding: "0.52vw 1.04vw",
                borderRadius: '0.52vw',
                height: "3.64vw"
            },
            attachmentItem: {
                gap: '1.04vw',
                fontSize: "0.93vw"
            },
            attachmentRemove: {
                width: '1vw',
                marginTop: '0.2vw',
                height: '1vw'
            },
            invalidMessage: {
                right: "1.8%"
            },
            inputError: {
                fontSize: "1vw",
                icon: {
                    width: "1.05vw",
                    height: "1.05vw"
                }
            }
        }
    }
}